import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import { AppName, CleanMessage } from "../../../util/app";
import LoadingSpinner from "../../../partials/loading";
import Select from "react-dropdown-select";
import { NEW_EMERGENCY_CONTACT } from "../../../queries/patient.query";
import { toast } from "react-toastify";
import { sendNotification } from "../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../event/model";

function EmergencyContact({ location, history, match }) {
    // Get patient reference

    const { id } = match.params;
    const _profileLink = `/home/patient/profile/${id}/summary`;
    // Authentication

    // local State
    const [relation, setRelationship] = useState(null);
    const nameRef = useRef();
    const telRef = useRef();
    const addressRef = useRef();

    // Mutation query
    const [createFunc, { loading }] = useMutation(NEW_EMERGENCY_CONTACT, {
        onCompleted: (d) => {
            if (d.UpdateEmergencyContact) {
                const { message, doc } = d.UpdateEmergencyContact;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                history.push(_profileLink);
                // document.location.href = _profileLink;
            }
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const title = "Emergency Contact";

    if (!id)
        return (
            <Redirect
                to={{
                    pathname: _profileLink,
                }}
            />
        );

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                <button
                                    onClick={() => {
                                        history.push(_profileLink);
                                    }}
                                    title="Back"
                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                >
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                {title} Form
                            </header>
                        </div>
                        <div className="card-body m-b-20">
                            <form
                                onSubmit={async (evt) => {
                                    evt.preventDefault();
                                    if (id)
                                        await createFunc({
                                            variables: {
                                                model: {
                                                    name: nameRef.current.value,
                                                    address: addressRef.current.value,
                                                    mobile: telRef.current.value,
                                                    relationship: relation,
                                                },
                                                id,
                                            },
                                        });
                                    else toast.warn("Invalid patient reference no!");
                                }}
                            >
                                <div className="form-row">
                                    <div className="col">
                                        <label className="control-label" htmlFor="next_name">
                                            Name
                                            <span className="required"> * </span>
                                        </label>
                                        <input type="text" name="next_name" id="next_name" required ref={nameRef} placeholder="enter full name" className="form-control input-height" />
                                    </div>
                                    <div className="col">
                                        <label className="control-label" htmlFor="tel_number">
                                            Telephone Number
                                            <span className="required"> * </span>
                                        </label>
                                        <input type="tel_number" id="tel_number" name="name" ref={telRef} required placeholder="enter telephone" className="form-control input-height" />
                                    </div>
                                </div>
                                <div className="form-group m-t-20">
                                    <Select
                                        placeholder="Relation to patient"
                                        onChange={([item]) => setRelationship(item.label)}
                                        separator
                                        multi={false}
                                        className="input-height"
                                        options={[
                                            {
                                                value: 1,
                                                label: "Father",
                                            },
                                            {
                                                value: 2,
                                                label: "Mother",
                                            },
                                            {
                                                value: 3,
                                                label: "Brother",
                                            },
                                            {
                                                value: 7,
                                                label: "Sister",
                                            },
                                            {
                                                value: 4,
                                                label: "Relative",
                                            },
                                            {
                                                value: 5,
                                                label: "Guardian",
                                            },
                                        ]}
                                    />
                                </div>
                                <div className="form-group m-t-20">
                                    <label className="control-label" htmlFor="address_id">
                                        Contact Address
                                        <span className="required"> * </span>
                                    </label>
                                    <textarea
                                        name="address-id"
                                        id="address-id"
                                        className="form-control form-control-textarea"
                                        required
                                        ref={addressRef}
                                        rows="6"
                                        placeholder="enter contact address"
                                    ></textarea>
                                </div>
                                <div>
                                    <LoadingSpinner loading={loading} />
                                </div>
                                <div className="form-group text-right m-t-20">
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                                        Submit
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            history.push(_profileLink);
                                        }}
                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
                                    >
                                        Cancel <i className="material-icons text-danger">close</i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default EmergencyContact;
